import React from "react";

import { addUrlPrefix } from "../../utils/urlValidations";
import A from "../elements/A";
import * as FontAwesome from "react-icons/fa";
import type { IconType } from "react-icons";
import { useAppSelector } from "../../hooks";

export interface IconBookmarkProps {
  widget_id?: string;
}

export default function IconBookmark(props: IconBookmarkProps) {
  const iconBookmarks = useAppSelector(state => state.layouts.iconBookmarks);
  const bookmark = iconBookmarks
    ? iconBookmarks.find(bookmark => bookmark.widget_id === props.widget_id)
    : null;

  const icons: Record<string, IconType> = FontAwesome;
  // Fall back if a saved icon no longer exists in react-icons v5.
  const Icon: IconType = icons[bookmark?.icon ?? "FaBeer"] ?? icons.FaBeer;
  return (
    <div className="bookmark-container">
      {bookmark ? (
        <A
          href={addUrlPrefix(bookmark.url)}
          target="_blank"
          rel="noopener noreferrer"
          className="body-layout-font"
        >
          <Icon style={{ width: "50px", height: "50px" }} />
        </A>
      ) : (
        <p className="body-layout-font">Bookmark is currently in edit mode</p>
      )}
    </div>
  );
}
